const ScrollWatcher = require("scroll-watcher");
const inViewport = require('in-viewport');


export function watchScroll(el, onEnterCallback, onExitCallback, offset) {
  const y = window.scrollY,
        elY = el.offsetTop,
        scroll = new ScrollWatcher(),
        that = this;

  let offsetAmount = offset || false;

  if (!inViewport(el)) {
    this.addUnseenClass(el);
  }

  if (!offsetAmount) {
    const dummy = document.createElement("div");
    dummy.style.height = "50vh";
    dummy.style.width = "0";
    dummy.style.position = "fixed";
    dummy.style.top = "0";
    dummy.style.left = "100%"
    document.body.appendChild(dummy);
    const h = dummy.offsetHeight;
    document.body.removeChild(dummy);
    console.log("Offset height of", h, "px set for: ", el);
    offsetAmount = h;
  } else {
    console.log("Offset height of", offsetAmount, "px already set for: ", el);
  }

  scroll.watch(el, offsetAmount)
    .on("enter", () => {
      that.unhide(el);
      if (onEnterCallback) {
        onEnterCallback()
      }
    })
    .on("exit", () => {
      if (onExitCallback) {
        onExitCallback()
      }
    });

}

export function addUnseenClass(el) {
  el.classList.add("unseen");
}

export function unhide(el) {
  el.classList.remove("unseen");
}

export function setNav(sectionId) {
  const nav = document.querySelector("header nav"),
        currentActive = nav.querySelector(".active"),
        targetActive = nav.querySelector("[href='"+sectionId+"']");

  if (currentActive) {
    currentActive.classList.remove("active");
  }
  targetActive.classList.add("active");
}

export function unsetNav(el, sectionId) {
  const y = window.scrollY,
        elY = el.offsetTop,
        nav = document.querySelector("header nav"),
        currentActive = nav.querySelector(".active"),
        targetActive = nav.querySelector("[href='"+sectionId+"']");

  if(y < elY) {
    currentActive.classList.remove("active");
    targetActive.classList.add("active");
  }
}